var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreCirecle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75004 7.87154C3.43741 11.1861 3.75987 15.7809 6.71741 18.7384C10.0369 22.0579 15.4188 22.0579 18.7382 18.7384C22.0577 15.4189 22.0577 10.037 18.7382 6.71759C15.7807 3.76005 11.1859 3.43759 7.87136 5.75022",
    stroke: "#2A2D34",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.72803L13 16.728",
    stroke: "#2A2D34",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.728L9 12.728",
    stroke: "#2A2D34",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreCirecle);
export default __webpack_public_path__ + "static/media/more_cirecle.8365cc3a535247fece7b8fe0fb03cf6c.svg";
export { ForwardRef as ReactComponent };